/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { ColorAliases } from 'styles/variables';
import numeral from 'numeral';

const format = n => numeral(n).format('0,0');

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
	set?: string | number,
	total?: string | number,
	divider?: string
}

/**
 * Displays set of total like: 10/20
 */
export const SetOfTotal: React.FC<Props> = ({
	set,
	total,
	divider = ' / ', // ' of ',
	...props
}) => {
	// STATELESS //
	if (set == null || total == null) divider = null
	return (
		<div
			css={wrapperStyle}
			{...props}
		>
			{set != null && <span css={setStyle}>{format(set)}</span>}
			{divider != null && <span css={dividerStyle}>{divider}</span>}
			{total != null && <span css={totalStyle}>{format(total)}</span>}
		</div>
	);
};

const wrapperStyle = css`
	flex: 0 0 auto;
`;

const setStyle = css`
	font-weight: bold;
	color: ${ColorAliases.PT_TEXT_COLOR_MUTED};
`;

const dividerStyle = css`
	color: ${ColorAliases.PT_TEXT_COLOR_DISABLED};
`;

const totalStyle = css`
	color: ${ColorAliases.PT_TEXT_COLOR_MUTED};
`;
